import { IColoredUser, UserI } from "@services/getUsers";

export enum ActionTypesUsersE {
  SET_USERS = "SET_USERS",
  CLEAR_USERS = "CLEAR_USERS",
  EDIT_USER_COLOR = "EDIT_USER_COLOR",
}

export interface ActionBaseUser {
  type: ActionTypesUsersE;
}

export interface ActionSetUsers extends ActionBaseUser {
  payload: {
    users: UserI[];
  };
}

export interface ActionEditUserColor extends ActionBaseUser {
  payload: IColoredUser;
}
